import { jsxs as s, jsx as o, Fragment as G } from "react/jsx-runtime";
import { Field as H, ComboboxButton as I, ComboboxOption as J, ComboboxOptions as K } from "@headlessui/react";
import { useState as R, useEffect as U } from "react";
import { twMerge as t } from "tailwind-merge";
import { ArrowButton as X } from "./components/arrow-button.mjs";
import { CloseButton as Y } from "./components/close-button.mjs";
import { FormSelectInput as Z } from "./components/form-select-input.mjs";
import { ListOptions as _ } from "./components/list-options.mjs";
import { getSelectedData as $ } from "./utils/get-selected-data.mjs";
import { useFilteredData as P } from "./hooks/use-filtered-data.mjs";
import { ComboboxSinge as oo } from "./components/combobox-singe.mjs";
import { getVirtualizedData as to } from "./utils/get-virtualized-data.mjs";
import { FieldLabel as eo } from "../form/field-label.mjs";
import { FieldErrorAndDescription as ro } from "../form/field-error-and-description.mjs";
import { useTranslation as so } from "../../i18n/hooks.mjs";
function Do({
  label: N,
  data: i,
  staticData: m,
  onChange: n,
  labelClassName: v,
  value: p,
  isPreFetching: c,
  placeholder: F,
  error: f,
  required: y,
  description: B,
  className: D,
  containerClassName: w,
  closeButtonClassName: O,
  arrowButtonClassName: S,
  fieldClassName: V,
  disabled: j,
  withoutCloseIcon: A,
  onOpen: u,
  onClose: a,
  dataTest: E,
  wrapperProps: L,
  loaderClassName: io,
  loaderWrapperClassName: ao,
  inputWrapperClassName: k,
  inputRef: z,
  statusIcon: d,
  statusIconClassName: M,
  ...Q
}) {
  const { t: T } = so(), [x, l] = R(!1);
  U(() => {
    x && u && (u(), l(!1));
  }, [x]);
  const r = $(p, i ?? m) ?? null, { filteredData: b, setQuery: h } = P(i), C = p !== void 0, e = j || c || C && (!i && !m), W = C && !A && !e;
  return /* @__PURE__ */ s("div", { className: t("relative flex flex-col gap-1", w), children: [
    /* @__PURE__ */ o(
      oo,
      {
        selectedData: r,
        virtual: to(b, T),
        onChange: n,
        disabled: e,
        onClose: () => {
          h(""), a == null || a();
        },
        children: (g) => /* @__PURE__ */ s(G, { children: [
          /* @__PURE__ */ s(H, { className: t("relative flex flex-col gap-1", V), children: [
            /* @__PURE__ */ o(
              eo,
              {
                wrapperAs: "label",
                wrapperProps: L,
                label: N,
                required: y,
                labelClassName: t("text-sm font-medium", v)
              }
            ),
            /* @__PURE__ */ s(I, { as: "button", className: t("relative", k), children: [
              /* @__PURE__ */ o(
                Z,
                {
                  dataTest: E,
                  inputRef: z,
                  isDisabled: e,
                  hasError: !!f,
                  open: g,
                  className: D,
                  placeholder: F,
                  selectedCaption: (r == null ? void 0 : r.caption) ?? "",
                  isPreFetching: c,
                  onFocus: () => l(!0),
                  onChange: (q) => {
                    l(!0), h(q);
                  }
                }
              ),
              d ? /* @__PURE__ */ o(
                "div",
                {
                  className: t(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    M
                  ),
                  children: d
                }
              ) : /* @__PURE__ */ o(
                X,
                {
                  isDisabled: e,
                  arrowButtonClassName: t(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    S
                  ),
                  open: g
                }
              )
            ] }),
            W && /* @__PURE__ */ o(
              Y,
              {
                isDisabled: e,
                closeButtonClassName: t(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  O
                ),
                onClick: () => n(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ o(
            _,
            {
              asOptions: K,
              asOption: J,
              data: b,
              ...Q
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ o(ro, { error: f, description: B })
  ] });
}
export {
  Do as FormSelect
};
